import { Box, Divider, Flex } from "@chakra-ui/react";
import { DurationDistance } from "~/generated/graphql.types";
import { SpotForSidebar } from "../convertType";
import { SpotStatInterface } from "./SpotStat";

export const BetweenTwoSpotListItems = ({
  prevSpot,
  nextSpot,
  allSpotsStats,
  withoutOptionalSpotsStats,
}: {
  prevSpot: SpotForSidebar;
  nextSpot: SpotForSidebar;
  allSpotsStats: DurationDistance | null | undefined;
  withoutOptionalSpotsStats: DurationDistance | null | undefined;
}) => {
  const prevSpotParentSpotId = prevSpot.parentSpotId;
  const nextSpotParentSpotId = nextSpot.parentSpotId;
  const Wrapper =
    prevSpotParentSpotId && nextSpotParentSpotId
      ? PrevIsChildAndNextIsChild
      : prevSpotParentSpotId && !nextSpotParentSpotId
      ? PrevIsChildAndNextIsParent
      : !prevSpotParentSpotId && nextSpotParentSpotId
      ? PrevIsParentAndNextIsChild
      : !prevSpotParentSpotId && !nextSpotParentSpotId
      ? PrevIsParentAndNextIsParent
      : Box;
  return (
    <Wrapper
      prevSpot={prevSpot}
      nextSpot={nextSpot}
      allSpotsStats={allSpotsStats}
      withoutOptionalSpotsStats={withoutOptionalSpotsStats}
    />
  );
};

const PrevIsChildAndNextIsChild = ({
  prevSpot,
  nextSpot,
  allSpotsStats,
  withoutOptionalSpotsStats,
}: {
  prevSpot: SpotForSidebar;
  nextSpot: SpotForSidebar;
  allSpotsStats: DurationDistance | null | undefined;
  withoutOptionalSpotsStats: DurationDistance | null | undefined;
}) => {
  return (
    <Flex alignItems="center" justifyContent={"space-between"} w="full">
      <SpotStatInterface stat={allSpotsStats} hasLeftMargin={true} />
    </Flex>
  );
};

const PrevIsChildAndNextIsParent = ({
  prevSpot,
  nextSpot,
  allSpotsStats,
  withoutOptionalSpotsStats,
}: {
  prevSpot: SpotForSidebar;
  nextSpot: SpotForSidebar;
  allSpotsStats: DurationDistance | null | undefined;
  withoutOptionalSpotsStats: DurationDistance | null | undefined;
}) => {
  return (
    <>
      <Flex alignItems="center" justifyContent={"space-between"} w="full">
        <SpotStatInterface stat={allSpotsStats} hasLeftMargin={true} />
      </Flex>
      <Divider my={2} />
      <Flex alignItems="center" justifyContent={"space-between"} w="full">
        <SpotStatInterface
          stat={withoutOptionalSpotsStats}
          hasLeftMargin={false}
        />
      </Flex>
    </>
  );
};

const PrevIsParentAndNextIsChild = ({
  prevSpot,
  nextSpot,
  allSpotsStats,
  withoutOptionalSpotsStats,
}: {
  prevSpot: SpotForSidebar;
  nextSpot: SpotForSidebar;
  allSpotsStats: DurationDistance | null | undefined;
  withoutOptionalSpotsStats: DurationDistance | null | undefined;
}) => {
  return (
    <>
      <Flex alignItems="center" justifyContent={"space-between"} w="full">
        <SpotStatInterface
          stat={withoutOptionalSpotsStats}
          hasLeftMargin={false}
        />
      </Flex>
      <Divider my={2} />
      <Flex alignItems="center" justifyContent={"space-between"} w="full">
        <SpotStatInterface stat={allSpotsStats} hasLeftMargin={true} />
      </Flex>
    </>
  );
};

const PrevIsParentAndNextIsParent = ({
  prevSpot,
  nextSpot,
  allSpotsStats,
  withoutOptionalSpotsStats,
}: {
  prevSpot: SpotForSidebar;
  nextSpot: SpotForSidebar;
  allSpotsStats: DurationDistance | null | undefined;
  withoutOptionalSpotsStats: DurationDistance | null | undefined;
}) => {
  return (
    <Flex alignItems="center" justifyContent={"space-between"} w="full">
      <SpotStatInterface
        stat={withoutOptionalSpotsStats}
        hasLeftMargin={false}
      />
    </Flex>
  );
};
